import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getAiRanking } from "@/services/v2/wantAdService";

const listingKeyOf = (r) =>
  r.mlsListingKey != null ? `mls:${r.mlsListingKey}` : `inv:${r.inventoryId}`;

// AI ranking for a want-ad's matches. byKey maps a match card's listing back
// to its ranking entry; enabled is false until the tenant's display switch is
// on AND a ranking exists, so callers can render exactly today's UI otherwise.
export default function useAiRanking(wantAdId, active = true) {
  const enabledQuery = !!active && Number.isInteger(Number(wantAdId));
  const { data } = useQuery({
    queryKey: ["aiRanking", Number(wantAdId)],
    queryFn: () => getAiRanking(Number(wantAdId)),
    enabled: enabledQuery,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return useMemo(() => {
    const result = data?.result;
    if (!result?.enabled || !result?.rankings?.length) {
      return { enabled: false, byKey: new Map(), rankings: [] };
    }
    const byKey = new Map();
    result.rankings.forEach((r) => byKey.set(listingKeyOf(r), r));
    return { enabled: true, byKey, rankings: result.rankings };
  }, [data]);
}

export const aiKeyForListing = (list) => {
  const mlsKey = list?.mlsListingKey ?? list?.ListingKey;
  if (mlsKey != null) return `mls:${mlsKey}`;
  const invId = list?.inventoryId ?? list?.Inv_Id;
  return invId != null ? `inv:${invId}` : null;
};
